<template>
  <nav
    class="w-full pl-2 pr-2 md:pr-10 py-2 transistion-all duration-700"
    :class="[
      backgroundColor,
      textColor,
      {
        'z-50 fixed top-0 left-0':fixed
      }
    ]"
  >
    <!-- desktop -->
    <div
      class="hidden md:flex items-center justify-between h-full"
    >
      <div class="flex items-center">
        <router-link
          to="/home"
        >
          <LogoSmall heightClass="h-8" isLink />
        </router-link>
      </div>

      <div class="flex items-center">
        <router-link
          v-for="(route, index) in routesList"
          :key="index"
          :to="route.path"
          class="uppercase text-xs tracking-widest font-sansBold font-medium"
          :class="[
            textColor,
            {
              'ml-10':index!==0
            }
          ]"
        >
          {{route.name}}
        </router-link>
      </div>

    </div>

    <!-- mobile -->
    <div
      class="flex md:hidden items-center justify-center h-full"
    >
      <router-link
        v-for="(route, index) in routesListLeft"
        :key="index"
        :to="route.path"
        class="uppercase text-xs tracking-widest font-medium"
        :class="{
          'ml-3':index !== 0
        }"
      >
        {{route.name}}
      </router-link>

      <div
        class="ml-3"
      >
        <router-link
          to="/home"
        >
          <LogoSmall heightClass="h-8" isLink />
        </router-link>
      </div>

      <router-link
        v-for="(route) in routesListRight"
        :key="route.path"
        :to="route.path"
        class="uppercase text-xs tracking-widest font-medium ml-3"
      >
        {{route.name}}
      </router-link>

    </div>
  </nav>
</template>

<script>
import LogoSmall from '@/components/logos/LogoSmall.vue'

export default {
  name: 'NavBar',
  props: {
    backgroundColor: {
      type: String,
      default: 'bg-white'
    },
    textColor: {
      type: String,
      default: 'text-black'
    },
    loggedInPaths: {
      type: Array,
      default: () => ['*']
    },
    loggedOutPaths: {
      type: Array,
      default: () => ['*']
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  components: {
    LogoSmall
  },
  data () {
    return {
    }
  },
  computed: {
    logoLocation () {
      var numOfLinks = 0
      var listToLoop = this.$router.options.routes
      for (var i = 0; i < listToLoop.length; i++) {
        if (this.$store.getters.token) {
          if (this.loggedInPaths.includes('*')) {
            if (!this.loggedInPaths.includes('!' + listToLoop[i].path)) numOfLinks++
          } else {
            if (this.loggedInPaths.includes(listToLoop[i].path)) numOfLinks++
          }
        } else {
          if (this.loggedOutPaths.includes('*')) {
            if (!this.loggedOutPaths.includes('!' + listToLoop[i].path)) numOfLinks++
          } else {
            if (this.loggedOutPaths.includes(listToLoop[i].path)) numOfLinks++
          }
        }
      }
      return numOfLinks / 2
    },
    routesList () {
      var toReturn = []
      var listToLoop = this.$router.options.routes
      for (var i = 0; i < listToLoop.length; i++) {
        if (this.$route.path === listToLoop[i].path) listToLoop[i].activeLink = true
        else listToLoop[i].activeLink = false

        // show different links depending on whether logged in
        if (this.$store.getters.token) {
          if (this.loggedInPaths.includes('*')) {
            if (!this.loggedInPaths.includes('!' + listToLoop[i].path)) toReturn.push(listToLoop[i])
          } else {
            if (this.loggedInPaths.includes(listToLoop[i].path)) toReturn.push(listToLoop[i])
          }
        } else {
          if (this.loggedOutPaths.includes('*')) {
            if (!this.loggedOutPaths.includes('!' + listToLoop[i].path)) toReturn.push(listToLoop[i])
          } else {
            if (this.loggedOutPaths.includes(listToLoop[i].path)) toReturn.push(listToLoop[i])
          }
        }
      }
      return toReturn
    },
    routesListLeft () {
      var toReturn = []
      var listToLoop = this.routesList
      for (var i = 0; i < listToLoop.length; i++) {
        if (i < this.logoLocation) {
          toReturn.push(listToLoop[i])
        }
      }
      return toReturn
    },
    routesListRight () {
      var toReturn = []
      var listToLoop = this.routesList
      for (var i = 0; i < listToLoop.length; i++) {
        if (i >= this.logoLocation) {
          toReturn.push(listToLoop[i])
        }
      }
      return toReturn
    }
  },
  methods: {
  }
}

</script>

<style lang="scss">

</style>
